import React, { Component } from 'react'

import Background from 'Assets/background/background-1.png'

export default class Layout extends Component {
	render() {
		return (
			<div className='layout'>
				{this.props.children}
				<img className='background' src={Background} alt='background' />
				<div className='circle'></div>
				<div className='footer'></div>
			</div>
		)
	}
}
